// Reads a rate container that may be stored as a FLAT object, an append-only
// HISTORY array (latest entry = current value), or flattened dotted keys (the
// detail header's record shape) — covers every caller without caring how the
// record was loaded.
function lastEntry(value) {
  if (Array.isArray(value)) return value[value.length - 1] ?? {};
  return value && typeof value === 'object' ? value : {};
}

const CURRENCY_SYMBOL = { USD: '$', INR: '₹', EUR: '€', GBP: '£' };

function pick(record, container, key) {
  const nested = lastEntry(record?.[container])[key];
  if (nested !== undefined && nested !== null && nested !== '') return nested;
  const flat = record?.[`${container}.${key}`];
  return flat !== undefined && flat !== null && flat !== '' ? flat : undefined;
}

function currentCandidateRate(ctx) {
  const record = ctx.selectedRecords?.[0] ?? {};
  const amount = pick(record, 'candidateRate', 'candidateAcceptedRate')
    ?? pick(record, 'candidateBudget', 'candidateBudgetStart');
  if (amount === undefined || Number(amount) === 0) return null;
  const currency = pick(record, 'candidateRate', 'candidateAcceptedCurrency')
    ?? pick(record, 'candidateBudget', 'candidateBudgetCurrency');
  const symbol = pick(record, 'candidateRate', 'candidateAcceptedCurrencySymbol')
    ?? pick(record, 'candidateBudget', 'candidateBudgetCurrencySymbol')
    ?? CURRENCY_SYMBOL[String(currency ?? '').toUpperCase()]
    ?? (currency || '$');
  const unit = pick(record, 'candidateRate', 'candidateAcceptedPayUnit')
    ?? pick(record, 'candidateBudget', 'candidateBudgetUnit')
    ?? '';
  return { amount, symbol, unit };
}

export const config = {
  title: 'Approve Rate',
  okText: 'Approve',
  width: 520,
  className: 'medium-modal',
  successMessage: 'Rate approved',
  getBodyText: (count, singularLabel, itemLabel, itemTitle, ctx) => {
    const rate = currentCandidateRate(ctx);
    return `Candidate Rate: ${rate ? `${rate.symbol}${rate.amount}${rate.unit ? `/${rate.unit}` : ''}` : '-'}`;
  },
  fields: [
    {
      name: 'candidateProposedRate',
      label: 'Proposed Rate',
      type: 'number',
      required: true,
      placeholder: 'Amount',
      min: 0,
      inlineRow: 'proposedRate',
      validator: (value, ctx) => {
        if (value === undefined || value === null || value === '') return undefined;
        const rate = currentCandidateRate(ctx);
        if (rate && Number(value) <= Number(rate.amount)) {
          return 'Proposed rate must be greater than Candidate Rate';
        }
        return undefined;
      },
    },
    {
      name: 'candidateProposedRateCurrency',
      label: 'Currency',
      type: 'select',
      required: true,
      inlineRow: 'proposedRate',
      defaultOptions: [
        { label: '$ USD', value: '$' },
        { label: '₹ INR', value: '₹' },
        { label: '€ EUR', value: '€' },
      ],
    },
    {
      name: 'candidateProposedRateUnit',
      label: 'Unit',
      type: 'select',
      required: true,
      inlineRow: 'proposedRate',
      defaultOptions: [
        { label: 'Year', value: 'yr' },
        { label: 'Month', value: 'mo' },
        { label: 'Week', value: 'wk' },
        { label: 'Hour', value: 'hr' },
        { label: 'Daily', value: 'day' },
      ],
    },
    {
      name: 'submitVia',
      label: 'Submit Via',
      type: 'radio',
      required: true,
      defaultOptions: [
        { label: 'Mail', value: 'Mail' },
        { label: 'VMS', value: 'VMS' },
      ],
    },
  ],
};
